module.exports = __webpack_public_path__ + "img/subscription.8628f542.jpg";